export default __webpack_public_path__ + "static/Indonesia-9ac621e58a9d5b8dbff007ede2b6d150.png";